import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import LayoutHeader from './header';
import LayoutFooter from './footer';
import DefaultHeader from './defaultHeader';
import DefaultFooter from './defaultFooter';
import './style';

var Layout = function Layout(props) {
  var hiddenIglooIcon = props.hiddenIglooIcon,
      className = props.className,
      style = props.style,
      headerConfig = props.headerConfig,
      footerConfig = props.footerConfig,
      withFixedPanel = props.withFixedPanel,
      children = props.children;
  var useBreakpoint = _Grid.useBreakpoint;

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md,
      lg = _useBreakpoint.lg,
      xl = _useBreakpoint.xl;

  var mobile = !md;
  var smallPC = !lg && md;
  var middlePC = !xl && lg;
  var bigPC = xl;
  var layoutContainerClass = '';
  var contentDom = null;
  var headerDom = null;
  var footerDom = null;

  if (mobile) {
    layoutContainerClass = classnames({
      'igloo-customer-mobile-container': true,
      'igloo-customer-mobile-container-with-panel': withFixedPanel
    });
  }

  if (smallPC) {
    layoutContainerClass = 'igloo-customer-layout-small';
  }

  if (middlePC) {
    layoutContainerClass = 'igloo-customer-layout-middle';
  }

  if (bigPC) {
    layoutContainerClass = 'igloo-customer-layout-big';
  }

  switch (Object.prototype.toString.call(children)) {
    case '[object Object]':
      // @ts-ignore
      if ((children === null || children === void 0 ? void 0 : children.type.displayName) === 'LayoutHeader') {
        headerDom = children;
        break;
      } //@ts-ignore


      if ((children === null || children === void 0 ? void 0 : children.type.displayName) === 'LayoutFooter') {
        footerDom = children;
        break;
      }

      contentDom = children;
      break;

    case '[object Array]':
      //@ts-ignore
      contentDom = children.filter(function (dom) {
        if (dom.type) {
          if (dom.type.displayName === 'LayoutHeader') headerDom = dom;
          if (dom.type.displayName === 'LayoutFooter') footerDom = dom;
          return dom.type.displayName !== 'LayoutHeader' && dom.type.displayName !== 'LayoutFooter';
        } // 希望所有的dom都被返回，处理一下dom=数字0这种情况


        return dom !== false;
      });
      break;

    default:
      contentDom = children;
  }

  return _jsxs("div", {
    style: style,
    className: classnames(layoutContainerClass, className),
    children: [!headerDom && !headerConfig && _jsx(DefaultHeader, {
      hiddenIglooIcon: hiddenIglooIcon
    }), headerConfig && _jsx(LayoutHeader, _objectSpread({}, headerConfig)), headerDom, _jsx("div", {
      className: "igloo-layout-center",
      children: _jsx("div", {
        className: "igloo-layout-content",
        children: contentDom
      })
    }), !footerDom && !footerConfig && _jsx(DefaultFooter, {
      hiddenIglooIcon: hiddenIglooIcon
    }), footerConfig && _jsx(LayoutFooter, _objectSpread({}, footerConfig)), footerDom]
  });
};

Layout.Header = LayoutHeader;
Layout.Footer = LayoutFooter;
export default Layout;